import { jsonldAggregateRatingBestRating } from './JsonldStore';

export const updateJsonldAggregateRatingBestRating = (value) => jsonldAggregateRatingBestRating.update((oldValue) => value);
